import { AceLoggerService } from '@logging/ace-logger.service';
import {Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Client} from '@app/layout/admin/services/api/client-interfaces';
import {ClientService} from '@shared/services/api/client.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {AceLogger} from '@logging/ace-logger';
import {AppConstants} from '@shared/util/app-constants';

@Component({
  selector: 'app-clients-select',
  templateUrl: './clients-select.component.html',
  styleUrls: ['./clients-select.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClientsSelectComponent), multi: true},
  ],
  standalone: false
})
export class ClientsSelectComponent implements OnInit, ControlValueAccessor {

  @Input() multiSelect = true;
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() placeholder = 'clients';
  @Input() clients: Client[];
  @Output() dataLoaded = new EventEmitter<Client[]>();

  @ViewChild('aceselect', { static: true })
  aceselect: AceSelectComponent;

  private readonly logger: AceLogger;

  readonly DROPDOWN_HOLDER_SELECTOR = AppConstants.DROPDOWN_HOLDER_SELECTOR;
  loading = false;

  constructor(private clientService: ClientService, logService: AceLoggerService) {
      this.logger = logService.create(ClientsSelectComponent.name);
  }

  ngOnInit() {
    if (this.clients == null) {
      this.loading = true;
      this.clientService.getAllClients().subscribe(clients => {
        this.clients = clients;
        this.logger.debug('ngOnInit() clients', this.clients);
        this.loading = false;
        this.dataLoaded.emit(this.clients);
      });
    } else {
      this.logger.debug('ngOnInit() supplied clients', this.clients);
      this.dataLoaded.emit(this.clients);
    }

    this.aceselect.registerOnChange(this.aceSelectOnChange);
    this.aceselect.registerOnTouched(this.aceSelectOnTouched);
  }

  onChange: (_) => void = (_) => {};
  onTouched: () => void = () => {};

  aceSelectOnChange = (selected: any) => {
    this.logger.debug('aceSelectChange() selectedClients', selected);
    this.onChange(selected);
  }

  aceSelectOnTouched = () => {
    this.onTouched();
  }

  writeValue(selected: any): void {
    this.logger.debug('writeValue() selectedClients', selected);
    this.aceselect.writeValue(selected);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
